module.exports = __webpack_public_path__ + "img/step3.32dd9e16.png";